export const tableData = [
  {
    age: 33,
    name: "Delaney Cortez",
    company: "IZZBY",
    email: "delaneycortez@izzby.com",
    phone: "+1 (844) 567-3740",
    image: "https://picsum.photos/id/74/900/900",
    address: "870 Hegeman Avenue, Crawfordsville, Kentucky, 2953",
    about:
      "Nostrud labore esse labore aliquip. Qui excepteur sint exercitation adipisicing deserunt ad veniam sunt ipsum nulla deserunt dolor est culpa. Eu deserunt nostrud ipsum mollit consectetur mollit et. Commodo mollit qui Lorem fugiat eiusmod dolore amet est officia aliqua. Est tempor veniam sit magna. Ullamco veniam eiusmod nostrud sit dolor. Est proident cupidatat proident ullamco irure commodo nisi fugiat adipisicing ullamco adipisicing ad officia.\r\n",
    date: "2023-01-10T09:02:53.870Z",
  },
  {
    age: 24,
    name: "Williamson Davenport",
    company: "ONTAGENE",
    email: "williamsondavenport@ontagene.com",
    phone: "+1 (844) 564-3345",
    image: "https://picsum.photos/id/40/900/900",
    address: "274 Forest Place, Vowinckel, Maine, 9510",
    about:
      "Quis ipsum ad deserunt cillum consequat do ex laboris sit eiusmod pariatur occaecat voluptate. Laborum ea sit duis mollit est sunt culpa ut et commodo consectetur veniam adipisicing amet. Ipsum mollit proident ea deserunt veniam Lorem duis aliquip dolor duis proident ut. Velit esse officia occaecat exercitation magna consequat ullamco ea nisi. Ad ea deserunt occaecat quis occaecat eiusmod ad do. Elit veniam quis aliquip qui nostrud laborum irure minim aute irure fugiat. Ullamco aliquip dolor est sit nulla consectetur.\r\n",
    date: "2023-01-10T09:02:53.870Z",
  },
  {
    age: 30,
    name: "Alexander Wong",
    company: "QUADEEBO",
    email: "alexanderwong@quadeebo.com",
    phone: "+1 (834) 497-2624",
    image: "https://picsum.photos/id/8/900/900",
    address: "420 Borinquen Pl, Kenvil, Vermont, 7377",
    about:
      "Dolor mollit elit est ex. Sit mollit laboris ad pariatur magna est amet veniam ad ad velit incididunt eu. Minim ipsum qui labore eiusmod magna veniam in magna pariatur Lorem.\r\n",
    date: "2023-01-10T09:02:53.870Z",
  },
  {
    age: 24,
    name: "Blanca Schultz",
    company: "CUJO",
    email: "blancaschultz@cujo.com",
    phone: "+1 (954) 412-2870",
    image: "https://picsum.photos/id/42/900/900",
    address: "144 Albemarle Terrace, Watchtower, Delaware, 2829",
    about:
      "Pariatur sunt dolore nostrud cillum cupidatat culpa. Ipsum laborum laboris reprehenderit Lorem culpa. Consequat duis do occaecat ipsum cupidatat sunt minim minim cillum commodo in qui culpa anim. Et ullamco nisi eiusmod laboris veniam laborum ullamco reprehenderit aliqua nulla labore. Elit excepteur sunt exercitation anim sint non ea.\r\n",
    date: "2023-01-10T09:02:53.870Z",
  },
  {
    age: 34,
    name: "Eunice Romero",
    company: "CENTREGY",
    email: "euniceromero@centregy.com",
    phone: "+1 (949) 568-3290",
    image: "https://picsum.photos/id/3/900/900",
    address: "698 Clermont Avenue, Harmon, Washington, 1094",
    about:
      "Nulla aute enim incididunt labore aute id officia fugiat tempor aliqua. Fugiat incididunt sint nisi eiusmod fugiat magna minim in. Officia eu enim magna magna pariatur deserunt esse amet veniam sint consequat est sit.\r\n",
    date: "2023-01-10T09:02:53.870Z",
  },
];
